import { render } from "./OverlayRoomSizeInput.vue?vue&type=template&id=13fc00a6&scoped=true"
import script from "./OverlayRoomSizeInput.vue?vue&type=script&lang=js"
export * from "./OverlayRoomSizeInput.vue?vue&type=script&lang=js"

import "./OverlayRoomSizeInput.vue?vue&type=style&index=0&id=13fc00a6&scoped=true&lang=scss"

import exportComponent from "/Users/vladimirkurockin/Projects/NowMedia/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13fc00a6"]])

export default __exports__